require("../sass/main.scss");
import ReactDOM from "react-dom";
import React from "react";
import { Provider } from "mobx-react";
import { AllRecallContent } from "./components/AllRecall";
import AllRecallStore from "./components/AllRecall/AllRecallStore";

const providerAllRecallContent = (
  <Provider allRecallStore={new AllRecallStore()}>
    <AllRecallContent />
  </Provider>
);

const allRecallContentRoot = document.getElementById("allRecall");

if (allRecallContentRoot) {
  ReactDOM.render(providerAllRecallContent, allRecallContentRoot);
}
